import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import EventDetail from "@/pages/EventDetail";
import Diagnostics from "@/pages/Diagnostics";
import GuestPage from "@/pages/GuestPage";
import { Loader2 } from "lucide-react";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy-deep">
        <Loader2 className="w-8 h-8 text-gold animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/g/:token" element={<GuestPage />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/events/:id" element={<Protected><EventDetail /></Protected>} />
            <Route path="/diagnostics" element={<Protected><Diagnostics /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
